import { inchesToMm } from 'utils/helpers';

/*
Responsible for getting the stock result into MM for consistent handling for 3D rendering.
The viewer accepts rendering in two units, mm or in, and it will handle its visualization
conversions based on the active native units of the scene (depending on the active part file).
*/
export const convertStockResultToMM = (result) => {
  const copy = JSON.parse(JSON.stringify(result));
  copy.buffer = inchesToMm(copy.buffer);
  copy.length = inchesToMm(copy.length);
  copy.sacrificialWidth = inchesToMm(copy.sacrificialWidth);
  copy.barEnd = inchesToMm(copy.barEnd);
  copy.stockOptions.forEach((opt) => {
    if (opt.diameter) {
      opt.diameter = inchesToMm(opt.diameter);
    }
    if (opt.length) {
      opt.length = inchesToMm(opt.length);
    }
    if (opt.width) {
      opt.width = inchesToMm(opt.width);
    }
    if (opt.height) {
      opt.height = inchesToMm(opt.height);
    }
  });
  return copy;
};
